<template>
    <v-dialog
        persistent
        v-model="display"
        width="500"
        >
        <v-card>
            <v-card-title>{{title}}</v-card-title>
            <v-card-subtitle>{{ $t('DRIVER_SUBTITLE') }}</v-card-subtitle>
            <v-card-text>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-form
                    v-if="!loading.data"
                    ref="form"
                    v-model="valid">

                    <v-text-field
                        :label="$t('DRIVER_NAME')"
                        v-model="form.name"
                        :rules="rules.name">
                    </v-text-field>
                    
                    <v-text-field
                        :label="$t('DRIVER_CONTACT')"
                        v-model="form.phone">
                    </v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    text
                    :disabled="!valid || loading.data || loading.submit"
                    :loading="loading.submit"
                    @click="submit">
                    {{ $t('BTN_SAVE') }}
                </v-btn>
                <v-btn
                    text
                    @click="close">
                    {{ $t('BTN_CANCEL') }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <AlertDialog 
            ref="alertDialog"/>
    </v-dialog>
</template>

<script>
import AlertDialog from '../components/AlertDialog'
import { mapState, mapActions } from 'vuex';
export default {
    name: "DriverDialog",

    components: {
        AlertDialog
    },

    data() {
        return {
            editMode: false,
            display: false,
            valid: false,
            id: null,
            form: {
                name: null,
                phone: null
            },
            rules: {
                name: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG')
                ]
            },
            loading: {
                data: false,
                submit: false
            }
        }
    },

    computed: {
        ...mapState("driver", ["driver"]),
        ...mapState("authentication", ["workshopId"]),
        title() {
            if(!this.editMode) return this.$t('DRIVER_NEW_TITLE');
            else return this.$t('DRIVER_EDIT_TITLE');
        }
    },

    methods: {
        ...mapActions("driver", ["fetchDriver", "fetchDrivers", "storeDriver", "updateDriver"]),
        async open(params) {
            this.loading.data = true;
            this.editMode = params.editMode;
            this.display = true;
            if(this.editMode) {
                this.id = params.id;
                await this.fetchDriver(this.id);
                this.form = this.driver;
            }
            this.loading.data = false;
        },
        close() {
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.display = false;
            this.loading.submit = false;
        },
        async submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeDriver(this.form)
                    .then(response => {
                        this.fetchDrivers();
                        this.close();
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.$emit("record", response.record);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            } else {
                this.updateDriver({form: this.form, id: this.id})
                    .then(response => {
                        this.fetchDrivers();
                        this.close();
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            }
        }
    }
}
</script>